import { Component, Fragment, Prop, h } from '@stencil/core';

import { onAppleWalletBadgeClick } from '../../../actions/actions.wallet-pass';
import { BrowserUtils } from '../../../utils/utils.browser';
import { isLucidTheme } from '../../../utils/utils.theme';

@Component({
  tag: 'offer-price',
  styleUrl: 'offer-price.css',
})
export class OfferPrice {
  @Prop() email: string = '';
  @Prop() expirationDate: string = new Date().toLocaleDateString();
  @Prop() hasDealerBoost: boolean = false;
  @Prop() buttonText: string = '';
  @Prop() offerAmount: number | string = 0;
  @Prop() offerId: string = '';
  @Prop() offerPriceButtonClick = () => {};
  @Prop() zip: string | number = '';
  @Prop() showOfferPriceButton: boolean = false;
  @Prop() theme: string = '';
  @Prop() showFinalActionButton = true;
  @Prop() showKelleyBuysYourCar = false;
  @Prop() isAppleWalletPassEnabled: boolean = false;

  OfferAmountSection = () => {
    const css = {
      'text-5xl my-3': true,
      'font-extrabold font-montserrat': true,
      'text-clrs-dark-green': this.hasDealerBoost,
      'text-clrs-green': !this.hasDealerBoost,
    };
    return (
      <div class={css} data-testid="certificate-offer-price">
        {this.offerAmount}
      </div>
    );
  };

  OfferTitleSection = () => {
    return (
      <h2 class="text-base pt-3 mdLrg:pt-2">
        {this.showKelleyBuysYourCar ? (
          'Kelley Buys Your Car Offer'
        ) : (
          <div>
            Your Kelley Blue Book<span>&#174;</span> Instant Cash Offer {this.hasDealerBoost && <span class="text-clrs-grey">&sup1;</span>}{' '}
            {this.hasDealerBoost && (
              <span>
                + Dealer Boost <span class="text-clrs-grey">&sup2;</span>
              </span>
            )}
          </div>
        )}
      </h2>
    );
  };

  DisclaimerSection = () => {
    const subHeaderClass = {
      'text-label mt-2 pb-6': !isLucidTheme(this.theme),
      invisible: isLucidTheme(this.theme),
    };

    return (
      <div class={subHeaderClass}>
        {this.showKelleyBuysYourCar ? (
          <Fragment>
            This Offer can only be redeemed with Kelley Blue Book.
            <br /> Inspection required.
          </Fragment>
        ) : (
          <Fragment>
            This offer can only be redeemed at a Participating Dealer. Kelley Blue Book doesn't redeem offers, purchase vehicles, or own/operate Participating Dealers.
          </Fragment>
        )}
      </div>
    );
  };

  AppleWalletSection = () => {
    return (
      <div class="mb-4 w-full flex justify-center mdLrg:justify-end">
        <apple-wallet-badge onClickHandler={onAppleWalletBadgeClick} />
      </div>
    );
  };

  render() {
    const { zip, offerId, email } = this;

    return (
      <div class="pb-10 xs:pb-3 xs:text-center mdLrg:text-right">
        <this.OfferTitleSection />
        <this.OfferAmountSection />
        {this.isAppleWalletPassEnabled && <this.AppleWalletSection />}
        <this.DisclaimerSection />

        <offer-hurricane-warning zipCode={this.zip.toString()} isEligible={true} />

        <div class="text-clrs-red font-semibold text-xs">Offer good until: {this.expirationDate}</div>
        <offer-short-description shouldDisplay={BrowserUtils.IS_MOBILE} offerId={offerId} email={email} zipCode={zip} />
        {this.showFinalActionButton && (
          <div class="mt-5 flex justify-center mdLrg:justify-end">
            <div class="w-auto">
              {this.showOfferPriceButton && <ico-button buttonStyle="secondary" label={this.buttonText} title={this.buttonText} whenClicked={() => this.offerPriceButtonClick()} />}
            </div>
          </div>
        )}
      </div>
    );
  }
}
